/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDataForTracking_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_physicalAddress_CreditApplicationAddress = { readonly __typename: 'CreditApplicationAddress', readonly countryCode: string | null, readonly postalCode: string | null };

export type GetDataForTracking_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_accountingSoftware_CreditApplicationAccountingSoftware = { readonly __typename: 'CreditApplicationAccountingSoftware', readonly accountingSoftwareKey: string | null };

export type GetDataForTracking_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo = { readonly __typename: 'CreditApplicationBusinessInfo', readonly entityType: _Types.CreditApplicationBusinessEntity | null, readonly industry: string | null, readonly physicalAddress: GetDataForTracking_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_physicalAddress_CreditApplicationAddress | null, readonly accountingSoftware: GetDataForTracking_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_accountingSoftware_CreditApplicationAccountingSoftware | null };

export type GetDataForTracking_creditApplication_CreditApplication_admin_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null };

export type GetDataForTracking_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null, readonly title: string | null };

export type GetDataForTracking_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly email: string | null, readonly firstName: string | null, readonly lastName: string | null };

export type GetDataForTracking_creditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null };

export type GetDataForTracking_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly companyDivvyUuid: string | null, readonly bdcOrgId: string | null, readonly businessInfo: GetDataForTracking_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo | null, readonly admin: GetDataForTracking_creditApplication_CreditApplication_admin_CreditApplicationPerson | null, readonly authorizedSigner: GetDataForTracking_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null, readonly beneficialOwners: ReadonlyArray<GetDataForTracking_creditApplication_CreditApplication_beneficialOwners_CreditApplicationPerson | null> | null, readonly outsourcedAccountant: GetDataForTracking_creditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson | null };

export type GetDataForTracking_Query = { readonly __typename: 'Query', readonly creditApplication: GetDataForTracking_creditApplication_CreditApplication | null };


export type GetDataForTrackingVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetDataForTracking = GetDataForTracking_Query;


export const GetDataForTrackingDocument = gql`
    query GetDataForTracking($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    companyDivvyUuid
    bdcOrgId
    businessInfo {
      entityType
      industry
      physicalAddress {
        countryCode
        postalCode
      }
      accountingSoftware {
        accountingSoftwareKey
      }
    }
    admin {
      id
      email
      firstName
      lastName
    }
    authorizedSigner {
      id
      firstName
      lastName
      email
      title
    }
    beneficialOwners {
      id
      email
      firstName
      lastName
    }
    outsourcedAccountant {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useGetDataForTracking__
 *
 * To run a query within a React component, call `useGetDataForTracking` and pass it any options that fit your needs.
 * When your component renders, `useGetDataForTracking` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataForTracking({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetDataForTracking(baseOptions: Apollo.QueryHookOptions<GetDataForTracking, GetDataForTrackingVariables> & ({ variables: GetDataForTrackingVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataForTracking, GetDataForTrackingVariables>(GetDataForTrackingDocument, options);
      }
export function useGetDataForTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDataForTracking, GetDataForTrackingVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataForTracking, GetDataForTrackingVariables>(GetDataForTrackingDocument, options);
        }
export function useGetDataForTrackingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDataForTracking, GetDataForTrackingVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDataForTracking, GetDataForTrackingVariables>(GetDataForTrackingDocument, options);
        }
export type GetDataForTrackingHookResult = ReturnType<typeof useGetDataForTracking>;
export type GetDataForTrackingLazyQueryHookResult = ReturnType<typeof useGetDataForTrackingLazyQuery>;
export type GetDataForTrackingSuspenseQueryHookResult = ReturnType<typeof useGetDataForTrackingSuspenseQuery>;
export type GetDataForTrackingQueryResult = Apollo.QueryResult<GetDataForTracking, GetDataForTrackingVariables>;